window.Visualizations.Highcharts.MapChart = Object.assign({}, window.Visualizations.Highcharts.Base, {
    render: function (opts) {
      this.renderChart(opts.highchart_html_id, opts, {
        chart: {
            type: 'map',
        },

        legend: {
            enabled: false
        },

        tooltip: {
            formatter: function () {
                return '<div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);"><div style="background-color: white; padding: 10px;"><b>' + this.point.name + '</b><br>' +
                    this.point.tooltip_value + ' m3/d</div></div>';
            }
        },

        mapNavigation: {
            enabled: true,
            buttonOptions: {
                verticalAlign: 'bottom'
            }
        },

        colorAxis: {
            min: 0
        },

        series: [{
            data: opts.series,
            name: 'Capacity',
            mapData: Highcharts.maps['custom/world'],
            joinBy: 'hc-key',
            states: {
                hover: {
                    color: '#BADA55'
                }
            },
            dataLabels: {
                enabled: true,
                format: '{point.value}'
            }
        }]
    });

}
});